var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m668-380 152-130 26 2q17 2 26.5 14t9.5 26q0 8-3 16t-11 14l-104 91 31 135q1 2 1 4.5v4.5q0 17-12 28.5T756-163q-5 0-10.5-1.5T735-169l-21-13-46-198Zm-94-292-42-98 9-22q5-12 15.5-18.5T578-817q11 0 21.5 6t15.5 18l55 130-96-9ZM294-287l126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143Zm-100 75 44-189L91-528q-8-6-10.5-14T78-558q0-14 9.5-26t26.5-14l194-17 75-178q5-12 15.5-18t21.5-6q11 0 21.5 6t15.5 18l75 178 194 17q17 2 26.5 14t9.5 26q0 8-2.5 16T749-528L602-401l44 189q1 3 1 9 0 17-12 28.5T607-163q-3 0-21-6L420-269 254-169q-5 3-10.5 4.5T233-163q-18 0-31-14.5t-8-34.5Zm226-248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelClass);
export default __webpack_public_path__ + "static/media/hotel_class.836d20b867e4db1a1b01ebf498ec51ae.svg";
export { ForwardRef as ReactComponent };